import Stade from '@/api/stades.js'

const state = {
  stades: {}
}

const mutations = {
  setStades: (state, stades) => {
    state.stades = stades
  }
}

const actions = {
  fetchStades: ({ state, commit }) => {
    Stade.list().then(({ hashmap }) => {
      commit('setStades', hashmap)
    })
    return state.stades
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
